// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Import getStorage from firebase/storage
import { getDatabase } from "firebase/database"; // Import getDatabase for Realtime Database
import { getRemoteConfig } from "firebase/remote-config";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDsiEsRChY9UyDu3JxvefsDne79nDKFzDQ",
  authDomain: "elite-ios-a6a68.firebaseapp.com",
  projectId: "elite-ios-a6a68",
  storageBucket: "elite-ios-a6a68.appspot.com",
  messagingSenderId: "693680147653",
  appId: "1:693680147653:web:8f8d0a321cec1d4a5a34ac",
  measurementId: "G-YLQHY9MT5C",
  databaseURL: "https://elite-ios-a6a68-default-rtdb.firebaseio.com" // Add Realtime Database URL
};

export const firebaseProjectId = firebaseConfig.projectId;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics, Authentication, Firestore, Storage, and Realtime Database
const analytics = getAnalytics(app);
export const auth = getAuth(app); // Export auth for authentication purposes
export const db = getFirestore(app); // Export db for Firestore access
export const storage = getStorage(app); // Export storage for Firebase Storage
export const rtdb = getDatabase(app); // Export rtdb for Realtime Database access

export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings = {
  fetchTimeoutMillis: 60_000,
  minimumFetchIntervalMillis:
    process.env.NODE_ENV === 'development' ? 0 : 300_000,
};
remoteConfig.defaultConfig = {
  popular_sign_v2: '[]',
};

